import { Typography, Box } from '@mui/material'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <Box
      bgcolor='#000'
      minHeight={150}
      color='#fff'
      px={3}
      py={5}
      display='flex'
      justifyContent='space-between'
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems='center'
    >
      <Box mb={3} order={{ sm: 2, xs: 2, md: 1, lg: 1 }} textAlign='center'>
        <Typography variant='h4' color='white' style={{ fontSize: 14 }}>
          © {new Date().getFullYear() ?? ''} HT Performance Tyre Sdn Bhd. 201901011388(1320716-D).
          All Rights Reserved.
        </Typography>
      </Box>
      <Box order={{ sm: 1, xs: 1, md: 2, lg: 2 }} mb={1}>
        {/* <Link href="https://www.facebook.com/MobilLubricantsMalaysia" newTab>
          <Tooltip title="Facebook">
            <IconButton>
              <FacebookIcon fontSize="large" style={{ fill: "white" }} />
            </IconButton>
          </Tooltip>
        </Link> */}
      </Box>
    </Box>
  )
}
